
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/farmakonaglyad",
      function () {
        return require("private-next-pages/farmakonaglyad/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/farmakonaglyad"])
      });
    }
  